function g(t, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
  return r.length >= e ? t.apply(null, r.slice(0, e).reverse()) : function() {
    for (var u = arguments.length, a = new Array(u), n = 0; n < u; n++)
      a[n] = arguments[n];
    return g(t, e, r.concat(a));
  };
}
export {
  g as default
};
